import { render, staticRenderFns } from "./DocumentPage2.vue?vue&type=template&id=2cf5e165&scoped=true&"
import script from "./DocumentPage2.vue?vue&type=script&lang=js&"
export * from "./DocumentPage2.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage2.vue?vue&type=style&index=0&id=2cf5e165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5e165",
  null
  
)

export default component.exports